(() => {
  const element = document.getElementById('ept-order-config');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  let queue = Promise.resolve();
  let timer;
  const request = async (path, body) => {
    const response = await fetch(root + path, body ? {
      method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)
    } : {headers: {Accept: 'application/json'}, cache: 'no-store'});
    const result = await response.json();
    if (!response.ok || result.status || result.errors) throw new Error(config.error);
    return result;
  };
  function plan(cart) {
    const counts = new Map();
    for (const item of cart.items) {
      const product = config.products.find(product => product.id === String(item.product_id));
      if (!product) continue;
      const current = counts.get(product.id) || {...product, quantity: 0};
      current.quantity += item.quantity;
      counts.set(product.id, current);
    }
    const invalid = [...counts.values()].filter(product => product.quantity < 5);
    const desired = new Map([...counts.values()].filter(product => product.quantity >= 5 && product.quantity < 10).map(product => [product.id, product]));
    const retained = new Set();
    const updates = {};
    for (const item of cart.items) {
      if (String(item.variant_id) !== config.fee) continue;
      const id = item.properties?._ept_fee_for;
      if (!desired.has(id) || retained.has(id)) updates[item.key] = 0;
      else {
        retained.add(id);
        if (item.quantity !== 1) updates[item.key] = 1;
      }
    }
    const additions = [...desired.values()].filter(product => !retained.has(product.id)).map(product => ({
      id: config.fee, quantity: 1, properties: {_ept_fee_for: product.id, Gjelder: product.title}
    }));
    return {invalid, updates, additions};
  }
  function show(message) {
    for (const area of document.querySelectorAll('[data-ept-order-status]')) {
      area.textContent = message;
      area.hidden = !message;
    }
  }
  function buttons(blocked) {
    for (const button of document.querySelectorAll('[name="checkout"]')) button.disabled = blocked;
  }
  async function reconcile() {
    let cart = await request('cart.js');
    let state = plan(cart);
    const changed = Object.keys(state.updates).length > 0 || state.additions.length > 0;
    if (Object.keys(state.updates).length) await request('cart/update.js', {updates: state.updates});
    if (state.additions.length) await request('cart/add.js', {items: state.additions});
    if (changed) {
      cart = await request('cart.js');
      try { sessionStorage.removeItem('cart-count'); } catch {}
    }
    state = plan(cart);
    if (Object.keys(state.updates).length || state.additions.length) throw new Error(config.error);
    const message = state.invalid.map(product => config.minimum.replace('[product]', product.title).replace('[count]', product.quantity)).join(' ');
    show(message);
    buttons(Boolean(message) || cart.items.length === 0);
    return {cart, changed, valid: !message};
  }
  function sync() {
    const pending = queue.catch(() => {}).then(reconcile);
    queue = pending;
    return pending;
  }
  async function checkout(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    clearTimeout(timer);
    buttons(true);
    show(config.wait);
    try {
      const result = await sync();
      if (!result.valid || !result.cart.items.length) return;
      location.assign(result.changed ? config.cart : root + 'checkout');
    } catch {
      show(config.error);
      buttons(false);
    }
  }
  window.EptOrder = {sync, plan};
  document.addEventListener('click', event => {
    if (event.target.closest('[name="checkout"], a[href="/checkout"]')) checkout(event);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout') checkout(event);
  }, true);
  const refresh = () => {
    clearTimeout(timer);
    buttons(true);
    timer = setTimeout(async () => {
      try {
        const result = await sync();
        if (result.changed) location.assign(config.cart);
      } catch {
        show(config.error);
        buttons(false);
      }
    }, 350);
  };
  document.addEventListener('cart:update', refresh);
  refresh();
})();
